var alertHistoryList = {
	caption: "Lista del historial de alertas",
	noResultsMessage: "No se encontraron resultados",
	actions: "Acciones",
	alert: {
		date: "Fecha de alerta",
		time: "Time",
		trigger: "Precio de alerta",
		limitType: "Limit type",
		limitAbove: "Última cotización: superior",
		limitBelow: "Última cotización: inferior"
	},
	security: {
		name: "Nombre",
		isin: "ISIN",
		lastPrice: "Precio final",
		lastPriceDateTime: "Fecha / Hora",
		assetClass: "Clase de activo",
		exchange: "Mercado"
	}
};
var es = {
	alertHistoryList: alertHistoryList
};

export { alertHistoryList, es as default };
